'use client';

import { Box, Divider, Paper, Typography } from '@mui/material';

type CorporateActionRow = {
  id: string;
  tipo: string;
  competencia: string;
  dataAprovacao: string;
  dataCom: string;
  dataPagamento: string;
  valor: string;
  observacoes: string;
};

type TickerCorporateActionsGridProps = {
  title: string;
  emptyMessage: string;
  rows: CorporateActionRow[];
};

export function TickerCorporateActionsGrid({ title, emptyMessage, rows }: TickerCorporateActionsGridProps) {
  if (rows.length === 0) {
    return (
      <Paper variant='outlined' sx={{ mt: 2, p: 2, borderStyle: 'dashed', color: 'text.secondary' }}>
        {emptyMessage}
      </Paper>
    );
  }

  return (
    <Paper variant='outlined' sx={{ mt: 2, p: { xs: 1.5, md: 2 } }}>
      <Typography variant='h6' fontWeight={700} sx={{ mb: 1.5 }}>
        {title}
      </Typography>
      <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
        {rows.map((row, index) => (
          <Box key={row.id}>
            <Box
              sx={{
                px: { xs: 1.5, md: 2 },
                py: 1.5,
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr 1fr',
                  md: 'repeat(4, minmax(0, 1fr))',
                  lg: 'repeat(8, minmax(0, 1fr))',
                },
                gap: { xs: 1.5, md: 2 },
              }}
            >
              <Metric label='Tipo' value={row.tipo} />
              <Metric label='Competência' value={row.competencia} />
              <Metric label='Data anúncio' value={row.dataAprovacao} />
              <Metric label='Data com' value={row.dataCom} />
              <Metric label='Data pagamento' value={row.dataPagamento} />
              <Metric label='Relação/valor' value={row.valor} />
              <Metric label='Observações' value={row.observacoes} />
            </Box>
            {index < rows.length - 1 ? <Divider /> : null}
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

type MetricProps = {
  label: string;
  value: string;
};

function Metric({ label, value }: MetricProps) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant='caption'
        sx={{
          display: 'block',
          fontWeight: 700,
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: 0.4,
        }}
      >
        {label}
      </Typography>
      <Typography
        variant='body2'
        sx={{
          fontWeight: 700,
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          lineHeight: 1.35,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
